export default __webpack_public_path__ + "static/media/chatops-img.1dfaadf9.png";